import { GET_PREVIOUS_SNAPSHOT_DATA_INTERNAL, RESET_GET_PREVIOUS_SNAPSHOT_DATA_INTERNAL } from "../../actionTypes/actionsTypes"
import defaultAsyncReducer from "../../defaultReducer"
import { AppAction, LocalAction } from "../../types"
import { SnapshotState } from "./getFullSnapshotDataReducer"

export interface PreviousSnapshotInternalState extends SnapshotState {
    found: boolean
}
const initialState: PreviousSnapshotInternalState = {
    loading: false,
    error: false,
    success: false,
    message: "",
    data: {} as Record<string, unknown>,
    found: false
}

function getPreviousSnapshotDataInternalReducer(state = initialState, action: AppAction | LocalAction) {
    if (action.type === RESET_GET_PREVIOUS_SNAPSHOT_DATA_INTERNAL) {
        return initialState
    } else {
        return defaultAsyncReducer(state, action as AppAction, GET_PREVIOUS_SNAPSHOT_DATA_INTERNAL)
    }
}

export default getPreviousSnapshotDataInternalReducer